import { GYPSUM } from 'HubStyleTokens/colors';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import Screens from '../../constants/routing/Screens';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { productsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { hasAnyTBSkuInProductDataSelector } from '../../selectors/ProductsSelectors';
import { SSM0004ExperimentSelector } from '../../utils/experiments/ssm0004';
import { Section } from '../common/SharedComponents';
import HighlightedFreeCard from './HighlightedFreeCard';
import HighlightedMerchCard from './HighlightedMerchCard';
import { ShadowCardGrid, ShadowColumn, StyledCardGrid, StyledCardGridWrapper } from './MerchCardSharedComponents';
import SSM0004HighlightedMerchCard from './SSM0004HighlightedMerchCard';
import SSM0004StarterCustomerPlatformUpsellCard from './SSM0004StarterCustomerPlatformUpsellCard';
import StarterCustomerPlatformUpsellCard from './StarterCustomerPlatformUpsellCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubTierInfo = ({
  productLine,
  selectedTab
}) => {
  const productLevels = getMerchCardsToShow({
    tab: selectedTab
  });
  const {
    isSSM0004Variant
  } = useAppSelector(SSM0004ExperimentSelector);
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const ownedProducts = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return [];
    return productsFromProductInventorySelector(state);
  });
  const isTBEligible = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return false;
    return hasAnyTBSkuInProductDataSelector(state);
  });
  const isFreePortal = !selectedTab && (ownedProducts === null || ownedProducts === void 0 ? void 0 : ownedProducts.length) <= 0;
  const isPublic = !!selectedTab;
  const isEnterpriseTab = selectedTab === 'enterprise';
  const showStarterCustomerPlatformUpsellCard = (isFreePortal || isPublic) && isTBEligible && !isEnterpriseTab;
  const starterCustomerPlatformUpsellCardIndex = isPublic ? 2 : 1;

  // if showing StarterCustomerPlatformUpsellCard, add 1 to the column count so the grid will have enough columns
  const columnCount = showStarterCustomerPlatformUpsellCard ? productLevels.length + 1 : productLevels.length;
  const merchCardComponents = productLevels.map((productLevel, index) => {
    let columnStart = index + 1;

    // Push merch cards to the right 1 place to make room for StarterCustomerPlatformUpsellCard
    if (index >= starterCustomerPlatformUpsellCardIndex) {
      const offset = showStarterCustomerPlatformUpsellCard ? 2 : 1;
      columnStart = index + offset;
    }
    const commonStyles = {
      msGridColumn: columnStart,
      // IE
      gridColumnStart: columnStart,
      paddingLeft: 28,
      paddingRight: 28
    };
    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(HighlightedFreeCard, {
        productLine: productLine,
        commonStyles: commonStyles,
        perMonth: false
      }, `${productLine}-${productLevel}`);
    }
    if (isSSM0004Variant) {
      return /*#__PURE__*/_jsx(SSM0004HighlightedMerchCard, {
        productLevel: productLevel,
        productLine: productLine,
        commonStyles: commonStyles,
        selectedTab: selectedTab
      }, `${productLine}-${productLevel}`);
    }
    return /*#__PURE__*/_jsx(HighlightedMerchCard, {
      productLevel: productLevel,
      productLine: productLine,
      commonStyles: commonStyles,
      selectedTab: selectedTab
    }, `${productLine}-${productLevel}`);
  });
  const shadowColumns = new Array(columnCount).fill('').map((value, index) => {
    // for the second column (StarterCustomerPlatformUpsellCard), use a gray background color
    if (showStarterCustomerPlatformUpsellCard && index === starterCustomerPlatformUpsellCardIndex) return /*#__PURE__*/_jsx(ShadowColumn, {
      style: {
        background: GYPSUM
      }
    }, index);
    return /*#__PURE__*/_jsx(ShadowColumn, {}, index);
  });
  return /*#__PURE__*/_jsx(Section, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx("div", {
      className: "flex-column align-center justify-center",
      children: /*#__PURE__*/_jsxs(StyledCardGridWrapper, {
        columns: columnCount,
        children: [/*#__PURE__*/_jsxs(StyledCardGrid, {
          columns: columnCount,
          children: [merchCardComponents, showStarterCustomerPlatformUpsellCard && (isSSM0004Variant ? /*#__PURE__*/_jsx(SSM0004StarterCustomerPlatformUpsellCard, {
            productLine: productLine,
            commonStyles: {
              msGridColumn: starterCustomerPlatformUpsellCardIndex + 1,
              // IE
              gridColumnStart: starterCustomerPlatformUpsellCardIndex + 1,
              paddingLeft: 28,
              paddingRight: 28
            },
            screen: Screens[productLine],
            selectedTab: selectedTab
          }) : /*#__PURE__*/_jsx(StarterCustomerPlatformUpsellCard, {
            productLine: productLine,
            commonStyles: {
              msGridColumn: starterCustomerPlatformUpsellCardIndex + 1,
              // IE
              gridColumnStart: starterCustomerPlatformUpsellCardIndex + 1,
              paddingLeft: 28,
              paddingRight: 28
            },
            screen: Screens[productLine],
            selectedTab: selectedTab
          }))]
        }), /*#__PURE__*/_jsx(ShadowCardGrid, {
          columns: columnCount,
          "aria-hidden": "true",
          children: shadowColumns
        })]
      })
    })
  });
};
export default HubTierInfo;